import React from "react";

export default function DateAndCity(props) {
  var data = props.data;
  const currentDate = new Date(data.dt * 1000);
  const options = { weekday: "long", timeZone: "UTC", weekdayLang: "en" };
  const currentDayOfWeek = currentDate.toLocaleDateString("en-US", options);
  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  const currentTime = currentDate.toLocaleTimeString("en-US", optionsTime);
  return (
    <div className="row mt-2 p-3 text-white">
      <div className="col-7 text-start">
        <h1 className="text-capitalize" id="currentCity">
          {data.name}, {data.country}
        </h1>
      </div>
      <div className="col-5 text-end pt-2">
        <span className="" id="day-and-time">
          {currentDayOfWeek}, {currentTime}
        </span>
      </div>
    </div>
  );
}
